import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Web3 from 'web3';
import detectEthereumProvider from '@metamask/detect-provider';
import '../style/employee.css'; // Import the CSS file
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const contractDOC = require("./EmployeeDocumentManagement.json");
const DOCABI = contractDOC.abi;
const AdvancedEmployeeDocumentManagementADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;

const Verifier = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [employeename, setEmployeename] = useState([]);
    const [verifiername, setVesrifiername] = useState([]);
    const { walletAddress } = location.state || {}; // Retrieve wallet address from state
    const [employeeDataList, setEmployeeDataList] = useState([]);
    const [loading, setLoading] = useState(true); // Added loading state
    const [selectedDocument, setSelectedDocument] = useState(null); // State for selected document
    const [selectedYear, setSelectedYear] = useState(''); // State for selected year
    const [selectedBranch, setSelectedBranch] = useState(''); // State for selected branch
    const [selectedDocumentType, setSelectedDocumentType] = useState(''); // State for selected document type

    const fetchEmployeeData = useCallback(async () => {
        setLoading(true); // Set loading to true before starting fetch
        const provider = await detectEthereumProvider();
        const web3 = new Web3(provider);
        const contract = new web3.eth.Contract(DOCABI, AdvancedEmployeeDocumentManagementADDRESS);
        const networkId = await web3.eth.net.getId();
        if (Number(networkId) !== 80002) { // 80002 is the network ID for Polygon Mumbai testnet
            toast.error('You are not connected to the correct network. Please switch to the Polygon Amoy testnet.');
            return; // Stop execution if network is incorrect
        }
        try {
            const DATA = [];
            const getemployeeAddresses = await contract.methods.getAllEmployees().call();
            for (let i = 0; i < getemployeeAddresses.length; i++) {
                const ids = await contract.methods.getEmployeeDocuments(getemployeeAddresses[i]).call();
                const verifier = await contract.methods.getApproverName(walletAddress).call();
                setVesrifiername(verifier)
                const info = await contract.methods.getEmployeeInfo(getemployeeAddresses[i]).call();
                setEmployeename(info.name);
                // console.log(info.name);
                // console.log(info.name);
                for (let index = 0; index < ids.length; index++) {
                    const employeeData = await contract.methods.getDocument(ids[index]).call();
                    DATA.push({
                        employeeName: info.name,
                        employeeID: employeeData.id,
                        addedAt: employeeData[4],
                        documentType: employeeData.documentType,
                        documentHash: employeeData.documentHash,
                        verificationStatus: employeeData.isApproved,
                        approvedBy: employeeData.approvedBy,
                        approvedAt: employeeData.approvedAt,
                        document: `${process.env.REACT_APP_PINATA_URL}${employeeData.documentHash}`,
                        year: info.department || 'NA',
                        // branch: info.branch || 'NA',
                        idnumber: info.idNumber
                    });
                }
            }
            setEmployeeDataList(DATA);
        } catch (error) {
            console.error('Error fetching employee data:', error);
            toast.error('Error fetching employee data.');
        } finally {
            setLoading(false); // Set loading to false after fetch completes
        }
    }, [DOCABI]);

    useEffect(() => {
        const checkUserRole = async () => {
            const provider = await detectEthereumProvider();
            if (provider) {
                const web3 = new Web3(provider);
                const contract = new web3.eth.Contract(DOCABI, AdvancedEmployeeDocumentManagementADDRESS);

                try {
                    const accounts = await provider.request({ method: 'eth_requestAccounts' });
                    const walletAddress = accounts[0]; // Get the first account address

                    const role = 'verifier'; // This should be dynamically set based on your logic
                    let roleConstant;
                    switch (role) {
                        case 'employee':
                            roleConstant = await contract.methods.EMPLOYEE_ROLE().call();
                            break;
                        case 'admin':
                            roleConstant = await contract.methods.ADMIN_ROLE().call();
                            break;
                        case 'verifier':
                            roleConstant = await contract.methods.APPROVER_ROLE().call();
                            break;
                        case 'owner':
                            roleConstant = null; // No predefined constant for owner
                            break;
                        default:
                            throw new Error("Unknown role");
                    }

                    if (roleConstant) {
                        const hasRole = await contract.methods.hasRole(roleConstant, walletAddress).call();
                        if (hasRole) {
                            navigate(`/${role}`, { state: { walletAddress } });
                        } else {
                            toast.error("You do not have the required role to access this page.");
                            navigate('/');
                        }
                    } else {
                        navigate('/owner', { state: { walletAddress } });
                    }
                } catch (error) {
                    console.error('Error during role check or navigation:', error);
                    toast.error("Check your role and try again.");
                    navigate('/');
                }
            } else {
                toast.error('MetaMask is not installed. Please install MetaMask and try again.');
                navigate('/');
            }
        };

        checkUserRole();
        if (walletAddress) {
            fetchEmployeeData();
        }
    }, [walletAddress, fetchEmployeeData, navigate]);

    const renderCell = (value) => {
        return value === undefined || value === null || value === '' ? 'NA' : value;
    };

    const getVerificationStatusStyle = (status) => {
        return {
            color: status ? 'green' : 'red',
            fontWeight: 'bold'
        };
    };

    function convertTimestampToDate(timestamp) {
        const date = new Date(timestamp * 1000);
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        };
        return date.toLocaleString('en-US', options);
    }

    const handleDownload = async (ipfsHash, fileName) => {
        try {
            const ipfsUrl = `${process.env.REACT_APP_PINATA_URL}${ipfsHash}`;
            const response = await fetch(ipfsUrl);
            if (!response.ok) {
                throw new Error('Failed to fetch file from IPFS');
            }
            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file from IPFS:', error);
            toast.error('Error downloading file from IPFS.');
        }
    };

    const approveDocument = async (employeeID) => {
        const provider = await detectEthereumProvider();
        const web3 = new Web3(provider);
        const contract = new web3.eth.Contract(DOCABI, AdvancedEmployeeDocumentManagementADDRESS);
        const accounts = await web3.eth.getAccounts();
        try {
            const result = await contract.methods.approveDocument(Number(employeeID)).send({ from: accounts[0] });
            toast.success('Transaction successful!');
            fetchEmployeeData();
        } catch (error) {
            console.log(error);
            console.error('Error verifying document:', error);
            toast.error('Transaction failed!');
        }
    };

    const openModal = (documentUrl) => {
        setSelectedDocument(documentUrl);
    };

    const closeModal = () => {
        setSelectedDocument(null);
    };

    // Filter data by year, branch, and document type
    const filteredData = employeeDataList
        .filter(data => (selectedYear ? data.year === selectedYear : true))
        .filter(data => (selectedBranch ? data.branch === selectedBranch : true))
        .filter(data => (selectedDocumentType ? data.documentType === selectedDocumentType : true));

    // Generate unique values for year, branch, and document type for filtering
    const years = Array.from(new Set(employeeDataList.map(data => data.year))).filter(year => year !== 'NA');
    const branches = Array.from(new Set(employeeDataList.map(data => data.branch))).filter(branch => branch !== 'NA');
    const documentTypes = Array.from(new Set(employeeDataList.map(data => data.documentType))).filter(docType => docType !== 'NA');

    return (
        <div>
            {walletAddress && <p><h2>Verifier: {verifiername}</h2></p>}
            {/* Filters */}
            <div className="filters">
                <label>
                    Department:
                    <select onChange={(e) => setSelectedYear(e.target.value)} value={selectedYear}>
                        <option value="">ALL Departments</option>
                        {years.map(year => (
                            <option key={year} value={year}>{year}</option>
                        ))}
                    </select>
                </label>
                {/* <label>
                    Branch:
                    <select onChange={(e) => setSelectedBranch(e.target.value)} value={selectedBranch}>
                        <option value="">All Branches</option>
                        {branches.map(branch => (
                            <option key={branch} value={branch}>{branch}</option>
                        ))}
                    </select>
                </label> */}
                <label>
                    Document Type:
                    <select onChange={(e) => setSelectedDocumentType(e.target.value)} value={selectedDocumentType}>
                        <option value="">All Document Types</option>
                        {documentTypes.map(docType => (
                            <option key={docType} value={docType}>{docType}</option>
                        ))}
                    </select>
                </label>
            </div>

            <div className="table-container">
                <h2>Documents</h2>
                {loading ? (
                    <div className="loader"></div> // Display circular loader
                ) : (
                    filteredData.length > 0 && (
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Department</th>
                                    {/* <th>Branch</th> */}
                                    <th>ID Number</th>
                                    <th>Document ID</th>
                                    <th>Added At</th>
                                    <th>Document Type</th>
                                    <th>Document Hash</th>
                                    <th>Verification Status</th>
                                    <th>Verified By</th>
                                    <th>Verified At</th>
                                    <th>View Document</th>
                                    <th>Download</th>
                                    <th>Verify</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{renderCell(data.employeeName)}</td>
                                        <td>{renderCell(data.year)}</td>
                                        {/* <td>{renderCell(data.branch)}</td> */}
                                        <td>{renderCell(data.idnumber)}</td>
                                        <td>{renderCell(data.employeeID?.toString())}</td>
                                        <td>{renderCell(convertTimestampToDate(Number(data.addedAt).toString()))}</td>
                                        <td>{renderCell(data.documentType)}</td>
                                        <td>{renderCell(data.documentHash)}</td>
                                        <td style={getVerificationStatusStyle(data.verificationStatus)}>
                                            {data.verificationStatus ? 'Verified' : 'Not Verified'}
                                        </td>
                                        <td>{renderCell(data.approvedBy?.join(', '))}</td>
                                        <td>
                                            {data.approvedAt ? convertTimestampToDate(data.approvedAt.toString()) : 'NA'}
                                        </td>
                                        <td>
                                        <button
                                                onClick={() => openModal(data.document)}
                                                className="view-document-button"
                                            >
                                                View Document
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                onClick={() => handleDownload(data.documentHash, `${employeename}-${data.documentType}-${data.employeeID}`)}
                                                className="download-button"
                                            >
                                                Download
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                onClick={() => approveDocument(renderCell(data.employeeID))}
                                                className="verify-button"
                                            >
                                                Verify
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )
                )}
            </div>
            <ToastContainer />

            {/* Modal for Viewing Document */}
            {selectedDocument && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close" onClick={closeModal}>&times;</span>
                        <iframe
                            src={selectedDocument}
                            title="Document Viewer"
                            width="100%"
                            height="600px"
                        ></iframe>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Verifier;
